import { motion } from "framer-motion"
import { Check } from "lucide-react"

export function Pricing() {
  return (
    <div className="flex flex-col lg:flex-row gap-8 bg-[#E0F1F8] py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto w-full">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
          {/* Left Section */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="lg:w-1/2 flex flex-col justify-center items-start lg:items-start lg:justify-start"
          >
            <div className="text-left lg:ml-[62px]">
              <h1
                className="text-gray-900 text-3xl sm:text-4xl lg:text-[38px] font-bold leading-tight"
                style={{ fontFamily: "Space Grotesk, sans-serif" }}
              >
                Flexible pricing
                <br />
                Options
                 
              </h1>
              <p
                className="text-gray-900 text-base sm:text-lg lg:text-xl mt-4 lg:mt-6 mb-6 lg:mb-8 font-semibold leading-relaxed"
                style={{ fontFamily: "Roboto, sans-serif" }}
              >
                Explore our flexible pricing options designed to accommodate businesses of all sizes, ensuring
                accessibility to powerful ERP solutions.
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-[#2D1A45] hover:bg-[#2D1A45]/90 text-white px-6 sm:px-8 py-2 sm:py-3 rounded-md transition-transform duration-300 text-sm sm:text-base"
              >
                Learn More
              </motion.button>
            </div>
          </motion.div>

          {/* Right Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="lg:w-1/2 flex justify-center relative"x
          >
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 border-2 border-black bg-[#B8E4FF] text-[#2D1A45] px-4 py-1 rounded-md text-xs sm:text-sm font-medium z-20">
              Best Value
            </div>
            <div className="w-full max-w-md border-2 border-black rounded-xl overflow-hidden">
              {/* Upper Card - Dark Background */}
              <div className="bg-[#2D1A45] text-white p-6 rounded-t-lg">
                <div className="space-y-6">
                  <h2 className="text-2xl font-semibold" style={{ fontFamily: "Space Grotesk, sans-serif" }}>
                    Plus Plan
                  </h2>
                  <div className="space-y-2">
                    <div className="flex items-baseline gap-1">
                      <span className="text-2xl">₹</span>
                      <span className="text-5xl font-bold" style={{ fontFamily: "Space Grotesk" }}>12,000</span>
                    </div>
                    <p className="text-base text-gray-300" style={{ fontFamily: "Space Grotesk" }}>Every year</p>
                    <p className="text-base text-gray-300">+₹29,999 License Registration</p>
                  </div>
                  <div>
                    <p
                      className="font-medium mb-2 text-base"
                      style={{ fontFamily: "Roboto, sans-serif" }}
                    >
                      Mid-Tier Plan for Growing Businesses
                    </p>
                    <p className="text-sm text-gray-300" style={{ fontFamily: "Space Grotesk" }}>30 day free trial</p>
                  </div>
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    className="w-full bg-white text-[#2D1A45] hover:bg-gray-100 py-3 rounded-md transition-transform duration-300 text-base"
                  >
                    Start Free Trial
                  </motion.button>
                </div>
              </div>

              {/* Lower Card - Light Background */}
              <div className="bg-[#F5EBE9] font-bold text-[#000000] p-6 rounded-b-lg space-y-4">
                {[
                  "All Intro Plan Features",
                  "Vehicle Logistics Management",
                  "Advanced Analytics",
                  "Invoice Printing (Thermal and Standard)",
                  "User Authority (Add/Edit Roles)",
                  "Multiple User Logins (up to 4 users)",
                  "Data Backup and Restore Options",
                  "WhatsApp Notifications for Transactions",
                  "Chat and Phone Support",
                ].map((feature, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                    className="flex items-center gap-2"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Check icon" width="24" height="24" viewBox="0 0 24 24">
                      <path class="highlighted" fill="#281A39" fill-rule="evenodd" d="M10.785 14.961L8 12.176L8.707 11.469L10.785 13.547L15.293 9.039L16 9.746L10.785 14.961ZM12 4C7.582 4 4 7.582 4 12C4 16.418 7.582 20 12 20C16.419 20 20 16.418 20 12C20 7.582 16.419 4 12 4Z"></path>
                    </svg>
                    <span
                      className="text-sm hover:scale-105 transition-transform duration-300"
                      style={{ fontFamily: "Roboto, sans-serif" }}
                    >
                      {feature}
                    </span>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

